<template>
    <div class="card mb-5 mb-xl-10">
        <div id="kt_account_settings_contracts" class="collapse show">
            <div class="card-body p-9">

                <div class="row">
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.fullname') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.fullname"  type="text" class="form-control form-control-solid">
                        </div>
                    </div>
                   
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.phone') }}</label>
                        <div class="form-group mb-2">
                            <input :value=" currentUser?.phone_code + currentUser?.phone"  type="text" class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.birthday') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.birthday"  type="text" class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.family') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.family_status?.title"  type="text" class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.address') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.address"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('folder.nationality') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.nationality['name_'+locale]"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.securityNumber') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.social_security_number"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.category') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.post_category?.title"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.entry_date') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.date_in_service"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.department') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.department?.name"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.post') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.post?.title"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                    <div class="col-6 mb-5">
                        <label for="" class="form-label fs-6 fw-bolder text-black">{{ $t('user.label.nbrHolidays') }}</label>
                        <div class="form-group mb-2">
                            <input :value="currentUser?.nbrHolidays"  type="text"
                                class="form-control form-control-solid">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end py-6 px-9">
            </div>

        </div>
    </div>
</template>
<script setup>

import { useLocales } from '@/composables/locales';
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';


const store = useStore()
const {locale} = useLocales()

const currentUser = computed(() => store.getters['user/currentUser'])


const getCurrentUser = () => {
    store.dispatch("user/getCurrentUser")
}

onMounted(() => {
    getCurrentUser()
})

</script>